import { forEachMaterial } from "./forEachMaterial";

export function setEmissive(rootObj: THREE.Object3D, emissive: THREE.Color) {
  forEachMaterial(rootObj, (material) => {
    if ("emissive" in material) {
      material.emissive = emissive;
    }
    if ("emissiveIntensity" in material) {
      material.emissiveIntensity = 1;
    }
  });
}
